import React from 'react';

class NoActionButton extends React.Component {
  render() {
    return (
      <p>
        <a className="slots__item-record btn alert-info" role="button">{this.props.message}</a>
      </p>
    );
  }
}

export default NoActionButton;
